export enum MetaltrackJobShift{
    day = 'day',
    night = 'night',
}